import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { instructionStoreData } from '../../stores/instructionsStore';
import { toJS } from 'mobx';

const Translations = observer(
    ({
        edit,
        page,
        onChange,
        formik,
    }: {
        edit: boolean;
        page: string;
        onChange: (key: string, e: React.ChangeEvent<HTMLTextAreaElement>) => void;
        formik: any;
    }) => {
        useEffect(() => {
            instructionStoreData.editPageTranslations = false;
            instructionStoreData.editModalTranslations = false;
        }, []);
        let currentTranslations = page === 'popup' ? instructionStoreData.modalTranslations : instructionStoreData.pageTranslations;
        let editInstructions = page === 'popup' ? instructionStoreData.editModalTranslations : instructionStoreData.editPageTranslations;
        let showInputs = Object.values(currentTranslations)[0] !== '' || editInstructions;
        return showInputs ? (
            <form onSubmit={formik.handleSubmit} style={{ width: '100%' }}>
                {Object.keys(currentTranslations).map((key, index) => {
                    if (key !== 'PK' && key !== 'SK') {
                        return (
                            <div key={`${key}_${index}`}>
                                <div className={`instructions-wrapper__text-wrapper__instruction-translation ${edit ? 'border-active' : ''}`}>
                                    <p title={key} className="label">{key}</p>

                                    <textarea
                                        name={key}
                                        id={key}
                                        key={`${index}-${key}`}
                                        onChange={(e) => onChange(key, e)}
                                        value={formik.values[key]}
                                    ></textarea>
                                </div>
                                <p className="error-msg">{formik.errors[key] && formik.touched[key] && formik.errors[key]}</p>
                            </div>
                        );
                    }
                })}
            </form>
        ) : (
            <div className="no-translation">
                <p>No translation for this language :(</p>
                <button
                    onClick={() => {
                        if (page === 'popup') {
                            instructionStoreData.editModalTranslations = true;
                        } else {
                            instructionStoreData.editPageTranslations = true;
                        }
                    }}
                    className="btn c-btn"
                >
                    Translate
                </button>
            </div>
        );
    }
);
export default Translations;
